// The brand asset itself, not a redraw of it. Same file the marketing site and the favicon
// use. It ships with white fills; CSS beats the presentation attribute, so the mark takes
// whatever colour the surface needs — plum on paper, cream on the chrome.
import raw from "@/assets/tankly-logo.svg?raw";
import { cn } from "@/lib/utils";

export function Logo({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "tankly-logo inline-block leading-none [&_svg]:h-full [&_svg]:w-auto",
        "[&_svg_circle]:fill-current [&_svg_path]:fill-current [&_svg_rect]:fill-current",
        className,
      )}
      // The SVG is a static, version-controlled brand asset — not user input, and never
      // reachable by one. This is the only place the app injects markup.
      dangerouslySetInnerHTML={{ __html: raw }}
      role="img"
      aria-label="Tankly"
    />
  );
}
